module.exports = __webpack_public_path__ + "img/janik-round.90daddc5.png";